import DatePicker from 'react-datepicker';
import events from 'lib/events';
import FollowUpApi from 'api/followUp';
import Loader from 'components/loader';
import moment from 'moment';
import phoneFormat from 'util/phoneformat';
import PrintableFullReport from '../components/printableFullReport';
import PropTypes from 'prop-types';
import React, {Component} from 'react';
import ReportApi from 'api/report';
import ReportDropDown from '../components/reportDropDown';
import ToolTip, {tooltipPositions} from 'components/ToolTip';
import {FormattedMessage, intlShape, injectIntl} from 'react-intl';
import {problemSelectFields, getProblemModel} from 'helpers/problemHelpers';
import {dateTimeFormats, reportDateFormat} from 'helpers/constants';
import ReportSummaryErrorHandler from '../components/reportSummaryErrorHandler';
import {makeCancelable} from 'helpers/cancelablePromise';

const dateOneWeekAgo = moment().subtract(7, 'days');


const _ProblemFollowUpsDetailedView = (props) => {
  const {formatMessage, report, emailColumn, clickedDismiss, clickedFollowUp, clickedRevert} = props;

  const   changeRevertClass = (event) => {
    event.target.classList.toggle('bl-revert');
    event.target.classList.toggle('bl-revert-over');
  };


  const hasFollowedUpOrDismissed = (report) => {
    let revert = <i className={'bl fa-2x pointer bl-revert revert-selector'}
                    onMouseOver={changeRevertClass}
                    onMouseLeave={changeRevertClass}
                    onClick={clickedRevert.bind(null, report['ID'])}/>;

    if (report['FollowedUp']) {
      return <span className='follow-up-summary'><i className='bl bl-called'/> {report['FollowedUp']} {revert}</span>;
    }
    if (report['Dismissed']) {
      return <span className='follow-up-summary'><i className='bl bl-cancel'/> {report['Dismissed']} {revert}</span>;
    }
    let f = <i className='bl fa-2x bl-follow-up pointer'
              onClick={clickedFollowUp.bind(null, report['ID'])}/>;
    let d = <i className='bl fa-2x bl-dismiss pointer'
              onClick={clickedDismiss.bind(null, report['ID'])}/>;

    return (
      <div>{f}{d}</div>
    );
  };

  return (
    <table className='table-biolab table-striped follow-up-table'>
      <thead style={{fontSize: '13px'}}>
        <tr>
          <th style={{width: '100px'}}><FormattedMessage id="general.primary.contact"/></th>
          <th><FormattedMessage id="general.primary.phone"/></th>
          <th style={{width: '130px'}}><FormattedMessage id="general.email.address"/></th>
          <th><FormattedMessage id="general.last.analysis"/></th>
          <th><FormattedMessage id="general.next.analysis"/></th>
          <th><FormattedMessage id="general.water.tester"/></th>
          <th style={{width: '120px', paddingTop: '10px'}}>
            <FormattedMessage id="general.system"/><br/><FormattedMessage id="general.email"/>
            <ToolTip title={formatMessage({id: 'general.email.status.tooltip'})}
                     position={tooltipPositions.topRight}
                     iconOnly
                     invert/>
          </th>
          <th style={{paddingLeft: '13px', width: '130px', paddingRight: '10px'}}>
            <FormattedMessage id="general.click.to"/><br/><FormattedMessage id="general.followup"/>
            <ToolTip body={<p><FormattedMessage id="general.followup.tooltip.one"/> <i className='bl bl-follow-up'/>
              <FormattedMessage id="general.followup.tooltip.two"/> <i className='bl bl-dismiss'/>
              <FormattedMessage id="general.followup.tooltip.three"/> <i className='bl bl-revert'/>
              <FormattedMessage id="general.followup.tooltip.four"/></p>}
                     position={tooltipPositions.topRight}
                     iconOnly
                     invert/>
          </th>
        </tr>
      </thead>
      <tbody>
        {
          report.map(row => {
            let customerLink = `#customer/${row.CustomerID}`;

            return (
              <tr key={row.ID}>
                <td>
                  <a href={customerLink}>{row.FullName}</a>
                </td>
                <td>{row.HomePhone}</td>
                <td>{row.Email}</td>
                <td>{moment(row.Created).format(dateTimeFormats.numeralDate)}</td>
                <td>{moment(row.NextAnalysisDate).format(dateTimeFormats.numeralDate)}</td>
                <td>{row.Tester}</td>
                <td>
                  {emailColumn(row, formatMessage)}
                </td>
                <td>
                  {hasFollowedUpOrDismissed(row)}
                </td>
              </tr>
            );
          })
        }
      </tbody>
    </table>
  );
};

_ProblemFollowUpsDetailedView.propTypes = {
  formatMessage: PropTypes.func.isRequired,
  report: PropTypes.array.isRequired,
  emailColumn: PropTypes.func.isRequired,
  clickedDismiss: PropTypes.func.isRequired,
  clickedFollowUp: PropTypes.func.isRequired,
  clickedRevert: PropTypes.func.isRequired,
};


class ProblemFollowUps extends Component {
  constructor(props) {
    super(props);

    let {formatMessage} = this.props.intl;

    const _filterOptions = {
      branch: -1,
      branchOptions: [
        {
          value: -1,
          label: formatMessage({id: 'general.all.stores'}),
        },
      ],
      poolType: -1,
      poolTypeOptions: [],
      tester: '',
      testerOptions: [
        {
          value: '',
          label: formatMessage({id: 'general.all'}),
        },
      ],
      problem: 0,
    };

    const branchesFilterable = this.props.branches.map(b => {
      return {
        value: b.id,
        label: b.name,
      };
    });

    _filterOptions.branchOptions = [
      {
        value: -1,
        label: formatMessage({id: 'general.all.stores'}),
      }, ...branchesFilterable];

    _filterOptions.poolTypeOptions = [
      {
        value: -1,
        label: formatMessage({id: 'general.all.systems'}),
      },
      {
        value: 1,
        label: formatMessage({id: 'general.pools'}),
      },
      {
        value: 2,
        label: formatMessage({id: 'general.spas'}),
      },
      {
        value: 3,
        label: formatMessage({id: 'general.swim.spas'}),
      },
    ];

    const testersFilterable = this.props.testers.map(b => {
      return {
        value: b.name,
        label: b.name,
      };
    });

    _filterOptions.testerOptions = [
      {
        value: '',
        label: formatMessage({id: 'general.all'}),
      }, ...testersFilterable];

    const problemOptions = problemSelectFields.map(p => {
      return {
        value: p.id,
        label: formatMessage({id: p.name}),
      };
    });

    _filterOptions.problemOptions = problemOptions;
    this.state = {
      loaded: true,
      summary: null,
      report: null,
      start: dateOneWeekAgo,
      end: moment(),
      startLabel: dateOneWeekAgo,
      endLabel: moment(),
      branches: this.props.branches.map(b => b.id),
      showNoDataMessage: false,
      error: false,
      ..._filterOptions,
    };
    this.clickedDismiss = this.clickedDismiss.bind(this);
    this.clickedFollowUp = this.clickedFollowUp.bind(this);
    this.clickedRevert = this.clickedRevert.bind(this);
  }

  componentWillUnmount() {
    this.setState({
      filterOptions: {},
    });
    if (this.fetching && !this.fetching.isFinished) {
      this.fetching.cancel();
    }
    if (this.followUpAction && !this.followUpAction.isFinished) {
      this.followUpAction.cancel();
    }
  }

  clickedDismiss(id) {
    if (this.followUpAction && !this.followUpAction.isFinished) {
      this.followUpAction.cancel();
    }
    (this.followUpAction = makeCancelable(FollowUpApi.dismiss(id)))
    .then(() => {
      this.state.report.find(x => x.ID === id)['Dismissed'] = moment.utc().format(dateTimeFormats.numeralDate);
      this.setState({report: this.state.report});
    })
    .catch(error => events.publish('error.user', error));
  }

  clickedFollowUp(id) {
    if (this.followUpAction && !this.followUpAction.isFinished) {
      this.followUpAction.cancel();
    }
    (this.followUpAction = makeCancelable(FollowUpApi.followUp(id)))
    .then(() => {
      this.state.report.find(x => x.ID === id)['FollowedUp'] = moment.utc().format('M/DD/YYYY');
      this.setState({report: this.state.report});
    })
    .catch(error => events.publish('error.user', error));
  }

  clickedRevert(id) {
    if (this.followUpAction && !this.followUpAction.isFinished) {
      this.followUpAction.cancel();
    }
    (this.followUpAction = makeCancelable(FollowUpApi.revert(id)))
    .then(() => {
      let report = this.state.report.find(x => x.ID === id);

      report['FollowedUp'] = '';
      report['Dismissed'] = '';
      this.setState({report: this.state.report});
    })
    .catch(error => events.publish('error.user', error));
  }

  emailColumn(report, formatMessage) {
    let FollowUpDate = report['FollowUpDate'] ? moment.utc(report['FollowUpDate']) : '';

    if (!report.Email || report.Email.trim() === '') {
      return <div><i className='bl bl-attention red'/> {formatMessage({id: 'general.no.email'})}</div>;
    }
    if (!FollowUpDate || FollowUpDate.isAfter(moment.utc())) {
      return <div><i className='bl bl-attention red'/> {formatMessage({id: 'general.email.not.sent'})}</div>;
    }
    if (!report['Emailed'] && FollowUpDate.isBefore(moment.utc())) {
      return <div><i className='bl bl-opted-out'/> {formatMessage({id: 'general.email.opted.out'})}</div>;
    }
    return <div>{FollowUpDate.format(dateTimeFormats.numeralDate)}</div>;
  }

  exportReport = () => {
    const {start, end, branch, poolType, branches, tester, problem} = this.state;

    ReportApi.getFollowUpReportExport(
      this.props.intl.locale,
      branch === -1 ? branches : branch,
      start.format(), end.format(),
      poolType === -1 ? null : poolType, getProblemModel({problem: problem}), tester, false);
  };


  printReport = () => {
    const {report, start, end, summary} = this.state;
    let {formatMessage} = this.props.intl;
    const tableColumns = [
      {name: formatMessage({id: 'general.primary.contact'}), key: 'FullName'},
      {name: formatMessage({id: 'general.primary.phone'}), key: 'HomePhone'},
      {name: formatMessage({id: 'general.email.address'}), key: 'Email'},
      {name: formatMessage({id: 'general.last.analysis'}), key: 'Created'},
      {name: formatMessage({id: 'general.next.analysis'}), key: 'NextAnalysisDate'},
      {name: formatMessage({id: 'general.water.tester'}), key: 'Tester'},
      {name: formatMessage({id: 'general.system.email'}), key: 'SystemEmail'},
      {name: formatMessage({id: 'general.followup'}), key: 'FollowedUp'},
    ];
    const summaryColumns = [
      {name: formatMessage({id: 'general.total.accounts'}), key: 'total'},
      {name: formatMessage({id: 'general.open.followups'}), key: 'open'},
      {name: formatMessage({id: 'general.water.clarity'}), key: 'water'},
      {name: formatMessage({id: 'general.algae'}), key: 'algae'},
      {name: formatMessage({id: 'general.surface.problems'}), key: 'surface'},
      {name: formatMessage({id: 'general.chlorine.demand'}), key: 'chlorine'},
      {name: formatMessage({id: 'general.total.maintenance'}), key: 'maintenanceSystems'},
    ];

    report.forEach((element) => {
      element.SystemEmail = this.emailColumn(element, formatMessage);
    }, this);
    return (
      <PrintableFullReport
        end={end.format(dateTimeFormats.numeralDate)}
        endLabel={formatMessage({id: 'general.end.date'})}
        formatMessage={formatMessage}
        start={start.format(dateTimeFormats.numeralDate)}
        startLabel={formatMessage({id: 'general.start.date'})}
        summaryColumns={summaryColumns}
        summaryData={summary}
        tableColumns={tableColumns}
        tableData={report}
        title={formatMessage({id: 'reports.followups.open.followups'})}
      />
    );
  };

  resetFilters = () => {
    this.setState({
      branch: -1,
      customerType: '',
      end: moment(),
      poolType: -1,
      problem: 0,
      start: dateOneWeekAgo,
      tester: '',
      startLabel: dateOneWeekAgo,
      endLabel: moment(),
    });
  };

  stateSetter(propName) {
    return value => this.setState({[propName]: value});
  }

  updateReport = () => {
    const {branch, start, end, poolType, branches, tester, problem} = this.state;

    this.setState({
      loaded: false,
      error: false,
    });

    if (this.fetching && !this.fetching.isFinished) {
      this.fetching.cancel();
    }else{
      this.setState({
        summary: null,
      });
    }

    const conditionalPush = (condition, list, pushValue) => {
      if (condition) {
        list.push(pushValue);
      }
    };

    (this.fetching = makeCancelable(ReportApi.getFollowUpReport(
      branch === -1 ? branches : branch,
      start.format(), end.format(),
      poolType === -1 ? null : poolType, getProblemModel({problem: problem}), tester, false)))
      .then(data => {
        if (data.report) {
          let {formatMessage} = this.props.intl;

          for (let row of data.report) {
            row.FullName = row.NameFirst + ' ' + row.NameLast;
            let problems = [];
            //Created string list of all problems of follow-up

            conditionalPush(row.Cloudy, problems, formatMessage({id: 'general.cloudy'}));
            conditionalPush(row.Hazy, problems, formatMessage({id: 'general.hazy'}));
            conditionalPush(row.Foaming, problems, formatMessage({id: 'preferences.foaming'}));
            conditionalPush(row.BlackAlgae, problems, formatMessage({id: 'general.black.algae'}));
            conditionalPush(row.GreenAlgae, problems, formatMessage({id: 'general.green.algae'}));
            conditionalPush(row.MustardAlgae, problems, formatMessage({id: 'general.mustard.algae'}));
            conditionalPush(row.SpaAlgae, problems, formatMessage({id: 'general.algae'}));
            conditionalPush(row.SlimeMold, problems, formatMessage({id: 'preferences.slime.mold'}));
            conditionalPush(row.Swampy, problems, formatMessage({id: 'preferences.swampy'}));
            conditionalPush(row.CopperStaining, problems, formatMessage({id: 'scan.copper.staining'}));
            conditionalPush(row.IronStaining, problems, formatMessage({id: 'scan.iron.staining'}));
            conditionalPush(row.UnknownStaining, problems, formatMessage({id: 'scan.unknown.staining'}));
            conditionalPush(row.ScaleBuildup, problems, formatMessage({id: 'scan.scale.buildup'}));
            conditionalPush(row.WaterlineBuildup, problems, formatMessage({id: 'scan.waterline.buildup'}));
            conditionalPush(row.OrganicStaining, problems, formatMessage({id: 'scan.organic.staining'}));
            conditionalPush(row.ChlorineDemand, problems, formatMessage({id: 'general.chlorine.demand'}));
            row.Problems = problems.join(', ');
            row.HomePhone = row.HomePhone ? phoneFormat(row.HomePhone) : '';
            row.FollowedUp = row.FollowedUp ? moment.utc(row.FollowedUp).format(dateTimeFormats.numeralDate) : '';
            row.Dismissed = row.Dismissed ? moment.utc(row.Dismissed).format(dateTimeFormats.numeralDate) : '';
            row.Created = row.Created ? moment.utc(row.Created).format(dateTimeFormats.numeralDate) : '';

            let FollowUpDate = row['FollowUpDate'] ? moment.utc(row['FollowUpDate']) : '';

            if (!row.Email || row.Email.trim() === '') {
              row.EmailString = formatMessage({id: 'general.no.email'});
            }
            if (!FollowUpDate || FollowUpDate.isAfter(moment.utc())) {
              row.EmailString = formatMessage({id: 'general.email.not.sent'});
            }
            if (!row['Emailed'] && FollowUpDate.isBefore(moment.utc())) {
              row.EmailString = formatMessage({id: 'general.email.opted.out'});
            }
            if (row.FollowUpDate) {
              row.EmailString = moment(row.FollowUpDate).format(dateTimeFormats.numeralDate);
            }
            if (row.NextAnalysisDate) {
              row.NextAnalysisDate = moment(row.NextAnalysisDate).format(dateTimeFormats.numeralDate);
            }
            if (row.Created) {
              row.Created = moment(row.Created).format(dateTimeFormats.numeralDate);
            }
          }
        }

        if (data && data.summary.total > 0) {
          this.setState({
            summary: data.summary,
            report: data.report,
            startLabel: start,
            endLabel: end,
            showNoDataMessage: false,
          });
        } else {
          this.setState({showNoDataMessage: true});
        }
      }).catch(err => {
        console.log(err);
        if (err && err.canceled) {return;}
        this.setState({showNoDataMessage: true});
      }).finally(() => {
        this.setState({
          loaded: true,
        });
      });
  };

  render() {
    let {formatMessage} = this.props.intl;
    const {start, end, problem, problemOptions, summary, loaded, tester,
      testerOptions, branch, branchOptions, poolType, poolTypeOptions, report, startLabel, endLabel, showNoDataMessage} = this.state;

    return (
      <div className='report-container'>
        <span className='description'><FormattedMessage id="reports.open.followups.description"/></span>
        <div className="report-options">
          <div className="top-title-bar">
            <FormattedMessage id="general.report.options"/>
          </div>
          <div className="select-options container-fluid">
            <div className='row'>
              <div className='col-sm-3'>
                <div className='form-group'>
                  <label><FormattedMessage id="general.date.from"/></label>
                  <div className='editable-datepicker'>
                    <DatePicker selected={start}
                                dateFormat={reportDateFormat}
                                maxDate={end.clone().subtract(1, 'days')}
                                onChange={((e) => {
                                  this.setState({start: e});
                                })}/>
                  </div>
                </div>
              </div>
              <div className='col-sm-3'>
                <div className='form-group'>
                  <label><FormattedMessage id="general.date.to"/></label>
                  <div className='editable-datepicker'>
                    <DatePicker selected={end}
                                dateFormat={reportDateFormat}
                                minDate={moment(start).clone()}
                                maxDate={moment()}
                                onChange={((e) => {
                                  this.setState({end: e});
                                })}/>
                  </div>
                </div>
              </div>
            </div>
            <div className='row'>
              <div className='col-sm-3'>
                <ReportDropDown value={branch}
                                label={formatMessage({id: 'general.store'})}
                                onChange={((e) => {
                                  this.setState({branch: parseInt(e.target.value)});
                                })}
                                options={branchOptions}/>
              </div>
              <div className='col-sm-3'>
                <ReportDropDown value={poolType}
                                label={formatMessage({id: 'general.system.type'})}
                                onChange={((e) => {
                                  this.setState({poolType: parseInt(e.target.value)});
                                })}
                                options={poolTypeOptions}/>
              </div>
              <div className='col-sm-3'>
                <ReportDropDown value={problem}
                                label={formatMessage({id: 'general.problem'})}
                                onChange={((e) => {
                                  this.setState({problem: e.target.value});
                                })}
                                options={problemOptions}/>
              </div>
              <div className='col-sm-3'>
                <ReportDropDown value={tester}
                                label={formatMessage({id: 'general.water.tester'})}
                                onChange={((e) => {
                                  this.setState({tester: e.target.value});
                                })}
                                options={testerOptions}/>
              </div>
            </div>
          </div>
          <div className='manage-options'>
            <div className='col-sm-12 button-group'>
              <span className='reset-button pull-right'
                    onClick={this.resetFilters}><FormattedMessage id="general.reset"/></span>
              <button className='btn btn-primary pull-right'
                      onClick={this.updateReport}><FormattedMessage id="reports.update.summary"/></button>
            </div>
          </div>
        </div>
        <Loader loaded={loaded}>
          <ReportSummaryErrorHandler error={this.state.error}>
            {summary ?
              <div className='col-sm-12 summary-container'>
                <div className='row'>
                  <h2>
                    <FormattedMessage id="reports.report.summary"/>
                    <span className='summary-date'> | <FormattedMessage id="general.date.range.labelled"
                                                                      values={{
                                                                        start: startLabel.format(dateTimeFormats.numeralDate),
                                                                        end: endLabel.format(dateTimeFormats.numeralDate),
                                                                      }}/>
                    </span>
                  </h2>
                  <p className='description'><FormattedMessage id="reports.reveal.report.summary"/></p>
                </div>
                <div className='row'>
                  <div className='col-sm-3 result'>
                    <label><FormattedMessage id="general.total.accounts"/></label>
                    <div>{summary.total}</div>
                  </div>
                  <div className='col-sm-3 result'>
                    <label><FormattedMessage id="general.open.followups"/></label>
                    <div>{summary.open}</div>
                  </div>
                </div>
                <div className='row'>
                  <div className='col-sm-3 result'>
                    <label><FormattedMessage id="general.water.clarity"/></label>
                    <div>{summary.water}</div>
                  </div>
                  <div className='col-sm-3 result'>
                    <label><FormattedMessage id="general.algae"/></label>
                    <div>{summary.algae}</div>
                  </div>
                  <div className='col-sm-3 result'>
                    <label><FormattedMessage id="general.surface.problems"/></label>
                    <div>{summary.surface}</div>
                  </div>
                  <div className='col-sm-3 result'>
                    <label><FormattedMessage id="general.chlorine.demand"/></label>
                    <div>{summary.chlorine}</div>
                  </div>
                  <div className='col-sm-3 result'>
                    <label><FormattedMessage id='general.total.maintenance'/></label>
                    <div>{summary.maintenanceSystems}</div>
                  </div>
                </div>
                <div className='pad-top'>
                  {report ?
                    <_ProblemFollowUpsDetailedView formatMessage={formatMessage}
                    report={report} emailColumn={this.emailColumn}
                    clickedDismiss={this.clickedDismiss}
                    clickedFollowUp={this.clickedFollowUp}
                    clickedRevert={this.clickedRevert}/> : <div/>}
                </div>
              </div> :
              <div className='summary-container'>
                <h2><FormattedMessage id="reports.report.summary"/></h2>
                <p><FormattedMessage id="reports.reveal.report.summary"/></p>
                {showNoDataMessage ?
                  <label className="report-no-data"><FormattedMessage id="reports.error.no.results"/></label> : ''}
                <div className="container-fluid custom-container-margins">
                  <div/>
                </div>
              </div>}
            <div className='col-sm-12 button-group shift-right'>
              <button className='btn btn-default pull-right'
                    disabled={(summary === null)}
                    onClick={(() => {
                      events.publish('print', this.printReport());
                    })}><FormattedMessage id="reports.print.summary"/></button>
              <button className='btn btn-primary pull-right'
                    onClick={this.exportReport}><FormattedMessage id="reports.export.report"/></button>
            </div>
          </ReportSummaryErrorHandler>
        </Loader>
      </div>
    );
  }
}

ProblemFollowUps.propTypes = {
  POSActive: PropTypes.bool,
  branches: PropTypes.any,
  intl: intlShape.isRequired,
  testers: PropTypes.any,
};

ProblemFollowUps.defaultProps = {
  branches: [],
  POSActive: false,
};

export default injectIntl(ProblemFollowUps);
